import { getIsLoggedIn } from '../../user';

/**
 * A hook to get whether the user is logged in or not.
 */
var useLoggedIn = function useLoggedIn() {
  return getIsLoggedIn();
};
export default useLoggedIn;